import type { Address } from "viem";

// @ts-ignore
function getProductionApi() {
    if (typeof window !== "undefined" && window?.location?.hostname) {
        // if the hostname includes .infinifi-frontend.pages.dev, use the debug api
        if (window.location.hostname.includes(".infinifi-frontend.pages.dev")) {
            return "https://staging-api.infinifi.org/api";
        }
        // if the hostname is either app.infinifi.org or preprod.infinifi.org, use the production api on .org domain
        if (["app.infinifi.org", "preprod.infinifi.org"].includes(window.location.hostname)) {
            return "https://eth-api.infinifi.org/api";
        }
    }
    // by default, use the production api on .xyz domain
    return "https://eth-api.infinifi.xyz/api";
}

export const API_BASE_URLS = {
    STAGING: "https://staging-api.infinifi.org/api",
    PRODUCTION: getProductionApi(),
} as const;

export const API_ENDPOINTS = {
    POINTS_LEGACY: {
        GET_USER_PROFILE: (address: string) => `/points/user/${address}`,
        PARTICIPATE: "/points/participate",
        TASKS: "/points/tasks",
        QUESTIONNAIRE_COMPLETION: "/points/questionnaire-completion",
        INTEGRATIONS: "/points/integrations",
    },
    POINTS: {
        GET_USER_PROFILE: (address: string) => `/points/v2/user/${address}`,
        PARTICIPATE: "/points/v2/participate",
        TASKS: "/points/tasks",
        QUESTIONNAIRE_COMPLETION: "/points/questionnaire-completion",
        INTEGRATIONS: "/points/integrations",
    },
    UNWINDING: {
        GET_USER_UNWINDING: (address: string) => `/protocol/unwinding/${address}`,
    },
    PROTOCOL: {
        VOTES: {
            GET_GLOBAL_VOTES_BY_EPOCH: (epoch: number) => `/protocol/votes/${epoch}`,
            GET_USER_VOTES: (epoch: number, userAddress: string) => `/protocol/votes/${epoch}/${userAddress}`,
        },
        DATA: "/protocol/data",
        USER_HISTORY: {
            GET_USER_TVL_HISTORY: (userAddress: string, daysAgo = 0) =>
                (() => {
                    const allowedDays = [0, 7, 30, 90, 365];
                    if (!allowedDays.includes(daysAgo)) {
                        throw new Error("daysAgo must be one of 0, 7, 30, 90, 365");
                    }
                    return `/protocol/user-history/tvl/${userAddress}?daysAgo=${daysAgo}`;
                })(),
            GET_USER_PNL_HISTORY: (userAddress: string, daysAgo = 0) =>
                (() => {
                    const allowedDays = [0, 7, 30, 90, 365];
                    if (!allowedDays.includes(daysAgo)) {
                        throw new Error("daysAgo must be one of 0, 7, 30, 90, 365");
                    }
                    return `/protocol/user-history/pnl/${userAddress}?daysAgo=${daysAgo}`;
                })(),
        },
        REDEMPTIONS: {
            GET_USER_REDEMPTIONS: (userAddress: string) => `/protocol/redemptions/${userAddress}`,
            GET_GLOBAL_REDEMPTIONS: "protocol/redemptions/",
            ESTIMATE_REDEMPTION: (amount: number) => `/simulate/redemptions?amount=${amount}`,
        },
        PNL: (address: Address) => `/protocol/pnl/${address}`,
    },
    ANNOUNCEMENT: {
        USER: (address: string) => `/user/${address}`,
        REGISTER: "/user/registerpointsprogram",
    },
} as const;
